import { Data, ParamMap, UrlSegment } from '@angular/router';

export interface RouterStateEssentials {
  url: UrlSegment[];
  data: Data;
  queryParamMap: ParamMap;
  paramMap: ParamMap;
}
